module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-message"
  }, [_c('div', {
    staticClass: "chat-message-content container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-3"
  }, [_c('div', [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
    staticClass: "chat-time"
  }, [_vm._v(_vm._s(_vm.dateTimeValue))])]), _vm._v(" "), _c('div', {
    staticClass: "column col-9"
  }, [_c('div', {
    staticClass: "chat-content"
  }, [_vm._v(_vm._s(_vm.message))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-159ca27e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChatMessage.vue
// module id = 118
// module chunks = 1